<div
  style="width: 100%; height: auto;padding-top:60px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;"
  *ngIf="cutom_loading">
  <img src="assets/img/brand/logo.png" style="max-width: 300px;" class="mb-4 w-100" />
  <p style="margin: 10px 0; font-size: 1.2em;">Chargement</p>
  <div
    style="width: 40px; height: 40px; border: 4px solid #ccc; border-top-color: #D63333; border-radius: 50%; animation: spin 1s linear infinite;">
  </div>
</div>
<ngx-spinner *ngIf="!cutom_loading" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Chargement...</p>
</ngx-spinner>
<router-outlet *ngIf="!cutom_loading"></router-outlet>